/* eslint-disable class-methods-use-this */
/**
 * Ter Steege Bouw
 *
 * @author Robuust
 * @author Jurriën Peters <jurrien@robuust.digital>
 * @author Bob Olde Hampsink <bob@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';

/**
 * Form controller.
 */
export default class extends Controller {
  static targets = ['form', 'label', 'success', 'error'];

  /**
   * Submit the form
   *
   * @param {Event} e
   */
  async submit(e) {
    e.preventDefault();

    const response = await fetch(window.location.href, {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
      body: new FormData(this.element),
    });
    const result = await response.json();

    if (response.ok && ('message' in result || 'member' in result)) {
      this.formTarget.classList.add('hidden');
      this.successTarget.classList.remove('hidden');
    } else {
      const errors = result.errors ? result.errors : [[result.message]];
      this.errorTarget.innerHTML = `
        <div class="bg-red-200 p-2 mb-6 inline-block">
          <span>Er is iets misgegaan bij het verzenden:</span>
          <ul>
            ${Object.entries(errors).map((error) => `<li>${error[1][0]}</li>`)}
          </ul>
        </div>
      `;
      this.formTarget.classList.add('hidden');
      this.errorTarget.classList.remove('hidden');
    }
  }

  /**
   * Toggle input active state.
   *
   * @param {Event} e
   */
  toggleInput(e) {
    e.target.closest('div').classList.toggle('is-active', e.target.value.length);
  }

  /**
   * Change label of the file input with the filename.
   *
   * @param {Event} e
   */
  fileInput(e) {
    const files = Array.from(e.target.files) ?? [];
    this.labelTarget.textContent = files.length ? files.map((f) => f.name).join(', ') : e.params.label;
  }
}
